import {
    ADD_INTEGRATION_REQUEST,
    ADD_INTEGRATION_RESULT,
    ADD_INTEGRATION_OPEN_MODAL,
    ADD_INTEGRATION_CLOSE_MODAL,
    ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST,
    ADD_INTEGRATION_GET_INTEGRATIONS_RESULT,
    ADD_INTEGRATION_CEREBRUMX_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    integrations: [],
    allFleets: [],
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case ADD_INTEGRATION_REQUEST:
            return { ...state, loading: true }

        case ADD_INTEGRATION_CEREBRUMX_REQUEST:
            return { ...state, loading: true }

        case ADD_INTEGRATION_RESULT:
            return { ...state, loading: false, result: action.payload }

        case ADD_INTEGRATION_OPEN_MODAL:
            return { ...state, openModal: true }

        case ADD_INTEGRATION_CLOSE_MODAL:
            return { ...state, openModal: false }

        case ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST:
            return { ...state, loading: true }

        case ADD_INTEGRATION_GET_INTEGRATIONS_RESULT:
            return { ...state, loading: false, integrations: action.payload.items }
        
        case ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST:
            return { ...state, loading: true }
        
        case ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT:
            return { ...state, loading: false, allFleets: action.payload }

        case CLEAR_REDUX:
            return ["", "ADD_INTEGRATION"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};